"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const manifest = {
    id: "named-zones",
    name: "Named Zones",
};
exports.default = manifest;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFuaWZlc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbWFuaWZlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFNLFFBQVEsR0FBc0I7SUFDbEMsRUFBRSxFQUFFLGFBQWE7SUFDakIsSUFBSSxFQUFFLGFBQWE7Q0FDcEIsQ0FBQztBQUVGLGtCQUFlLFFBQVEsQ0FBQyJ9